(() => {
  if (window.postbusPlatformInitialized) return;
  window.postbusPlatformInitialized = true;
  const closeMenus = (except) => document.querySelectorAll('[data-pbx-header] details[open]').forEach(menu => { if (menu !== except && !menu.contains(except)) menu.open = false; });
  document.addEventListener('click', event => { if (!event.target.closest('[data-pbx-header]')) closeMenus(); });
  document.addEventListener('focusin', event => { closeMenus(event.target.closest('[data-pbx-header] details')); });
  document.addEventListener('toggle', event => { if (event.target.matches?.('[data-pbx-header] details') && event.target.open) closeMenus(event.target); }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('[data-pbx-header] details[open]');
    if (open) { closeMenus(); open.querySelector('summary')?.focus(); }
  });
  document.addEventListener('postbus:cart-updated', event => {
    const count = event.detail?.cart?.item_count ?? event.detail?.item_count;
    if (!Number.isSafeInteger(count) || count < 0) return;
    document.querySelectorAll('[data-pbx-cart-count]').forEach(el => { el.textContent = String(count); el.hidden = count === 0; });
    document.querySelectorAll('[data-pbx-cart-label]').forEach(link => {
      link.setAttribute('aria-label', link.dataset.pbxCartLabel.replaceAll('__PBX_CART_COUNT__', String(count)));
    });
  });
  window.addEventListener('pageshow', async event => {
    if (!event.persisted) return;
    const cartPage = document.querySelector('pbx-cart');
    if (cartPage?.refresh && !cartPage.busy) {
      cartPage.lock(true);
      try { if (!await cartPage.refresh()) throw new Error(cartPage.dataset.error); }
      catch (_) { if (cartPage.isConnected) cartPage.notice(cartPage.dataset.error, true); }
      finally { if (cartPage.isConnected) cartPage.lock(false); }
      return;
    }
    const drawer = window.PostbusDrawer;
    if (drawer?.dialog?.open) {
      if (!drawer.busy) void drawer.load();
      return;
    }
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(root.replace(/\/?$/, '/') + 'cart.js', { credentials:'same-origin', cache:'no-store', signal:AbortSignal.timeout(10000), headers:{ Accept:'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (Number.isSafeInteger(cart.item_count) && cart.item_count >= 0) document.dispatchEvent(new CustomEvent('postbus:cart-updated', { detail:{ cart } }));
    } catch (_) {}
  });
})();

